<template>

    <div class="row card-group-md-row justify-content-center" style="padding-top:15px;">


        <template v-for="(product, index) of products" :key="index">

            <Producto v-if="(product.show == true && quotation == true) || (quotation == false)"

                :product="product"
                :quotation="quotation"
                :idPresupuesto="idPresupuesto"
                :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
                :productoAnterior="productoAnterior"
                @clickProducto="clickProducto"
                :mostrarInfo="mostrarInfo"
                >
                
            </Producto>

        </template>


    </div>

</template>

<script>


import Producto from './Producto.vue'


export default {
  name: 'Fila',
  components : {Producto},
  emits: ["clickProducto"],
  props: {
    
    products : Array,
    quotation: Boolean,
    UrlDescargaPresupuesto: String,
    productoAnterior: Boolean,
    idPresupuesto: String,
    mostrarInfo: Boolean


  },


  mounted: async function(){


  },
  methods: {

    clickProducto : async function(producto, price, tipo){
            
        await this.$emit("clickProducto", producto, price, tipo);


    }

  }

}

</script>

<style lang="scss" scoped>

    @media only screen and (min-width: 768px) {


        .card-group-md-row {
            box-shadow: none;

        }

    }

</style>